import AbstractCustomFieldsSettingsPageController from './abstract-custom-fields';

export default class ContactCustomFieldsSettingsPageController extends AbstractCustomFieldsSettingsPageController {

    _getHeadline() {
        return 'Contact custom fields';
    }

    _getCustomFieldCount() {
        return 40;
    }

    _getCustomFieldSuffix() {
        return '_name';
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/custom-fields/contact-custom-fields.js